import { Tag, TagProps } from "@chakra-ui/react";

export default function BaseActionStatus({ children, ...rest }: TagProps) {
  return (
    <Tag size="sm" height="24px" fontSize="xs" {...rest}>
      {children}
    </Tag>
  );
}
